import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Stack } from '@mui/material';

// component
import Iconify from '../../../components/iconify';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onFilterClick: PropTypes.func,
  deactivatedMembersClick: PropTypes.func,
  markAllAttendance: PropTypes.func,
  unMarkAllAttendance: PropTypes.func,
};

export default function UserListToolbar({
  numSelected,
  filterName,
  onFilterName,
  onFilterClick,
  markAllAttendance,
  deactivatedMembersClick,
  showDeactivatedMembersIcon,
  unMarkAllAttendance
}) {
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search member..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Stack direction="row-reverse" gap={1}>
          <Tooltip title="Deactivate">
            <IconButton>
              <Iconify icon="flowbite:user-remove-solid" />
            </IconButton>
          </Tooltip>

          {/* mark all marked attendance button */}
          <Tooltip title="Mark attendance">
            <IconButton onClick={markAllAttendance}>
              <Iconify icon="mdi:checkbox-marked-circle-plus-outline" />
            </IconButton>
          </Tooltip>

          {/* mark all marked attendance button */}
          <Tooltip title="Unmark attendance">
            <IconButton onClick={unMarkAllAttendance}>
              <Iconify icon="jam:undo" />
            </IconButton>
          </Tooltip>
        </Stack>
      ) : (
        <div>
          {showDeactivatedMembersIcon && (
            <Tooltip title="Deactivated members">
              <IconButton onClick={deactivatedMembersClick}>
                <Iconify icon="flowbite:user-remove-solid" />
              </IconButton>
            </Tooltip>
          )}
          {/* to be implemented later */}
          <Tooltip title="Filter list">
            <IconButton onClick={onFilterClick}>
              <Iconify icon="ic:round-filter-list" />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </StyledRoot>
  );
}
